<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      // 是否显示侧边栏
      menuList: []
    }
  },
  created() {

    this.menuList = []
    let createMenu = (item) => {
      if (item.children) {
        for (let itemDetail of item.children) {
          createMenu(itemDetail)
        }
      } else {
        this.menuList.push(item)
      }
    }
    for (let item of this.$store.state.menulist) {
      createMenu(item)
    }

    let toPath = ''
    if (this.menuList.length > 0) {
      this.$store.commit('set_activeIndex', 0)
      toPath = this.menuList[0].md5Path
    }
    // for (let item of this.menuList) {
    //   if (item.name === '汇总') {
    //     toPath = item.md5Path
    //   }
    // }
    this.$router.replace(toPath)
  }
}
</script>

<style lang="less" scoped>
</style>
